import { useState } from 'react';
import { toast } from 'sonner';
import { founderAdminApi } from '@/lib/founderApi';
import { errMsg } from '@/lib/digitalApi';

export const SaleModeCard = ({ mode, onChanged }) => {
  const [busy, setBusy] = useState(false);
  const live = mode === 'live';
  const change = async () => {
    const next = live ? 'coming_soon' : 'live';
    if (!window.confirm(live ? 'Switch back to Coming Soon? Public purchases will be disabled.' : 'Put the Blueprint Builder ON SALE? Anyone will be able to buy it.')) return;
    setBusy(true);
    try { await founderAdminApi.setSaleMode(next); toast.success(next === 'live' ? 'Now on sale' : 'Set to Coming Soon'); onChanged(); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="mt-8 bg-white border border-[#eae4d8] rounded-xl p-5 flex flex-wrap items-center justify-between gap-4" data-testid="fb-sale-mode-card">
      <div>
        <div className="text-[10px] tracking-[0.22em] uppercase text-[#888]">Sales status</div>
        <div className="mt-1 text-lg" data-testid="fb-sale-mode-status">{live ? 'On Sale: public purchases enabled' : 'Coming Soon: public purchases disabled'}</div>
      </div>
      <button onClick={change} disabled={busy} className={`text-xs uppercase tracking-[0.14em] px-5 py-2 rounded-full ${live ? 'border border-[#111]' : 'bg-[#111] text-white'}`} data-testid="fb-sale-mode-toggle">
        {live ? 'Switch to Coming Soon' : 'Put On Sale'}
      </button>
    </div>
  );
};
